import { EChartsOption } from 'echarts';

export const initChartOptions = (
  xAxisData: string[],
  yAxisData: number[],
  data1: any,
  data2: any,
  data3: any,
  translations: string[]
): EChartsOption => ({
  textStyle: {
    fontFamily: 'Horeca',
  },
  series: [
    {
      name: translations[0],
      type: 'line',
      data: data1,
      color: '#ea4336',
    },
    {
      name: translations[1],
      type: 'line',
      data: data2,
      color: '#4285f4',
    },
    {
      name: translations[2],
      type: 'line',
      data: data3,
      color: '#34a852',
    },
  ],
  xAxis: {
    type: 'category',
    data: xAxisData,
    splitLine: {
      show: true,
      lineStyle: {
        color: '#f4f4f4',
      },
    },
    axisLine: {
      lineStyle: {
        color: '#979797',
        type: 'dashed',
      },
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      color: 'rgba(51, 51, 51, 0.6)',
      fontSize: 12,
    },
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true,
      lineStyle: {
        color: '#979797',
        type: 'dashed',
        width: 1,
      },
    },
    axisLine: {
      show: false,
      onZero: true,
      lineStyle: {
        type: 'dashed',
      },
    },
    axisTick: {
      show: true,
      length: 5,
      lineStyle: {
        type: 'dashed',
      },
    },
    axisLabel: {
      color: '#333333',
      fontSize: 12,
      verticalAlign: 'bottom',
    },
    splitNumber: 2,
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  grid: {
    left: '0%',
    right: '4%',
    bottom: '10%',
    top: '20%',
    height: '140px',
    containLabel: true,
  },
  legend: {
    orient: 'horizontal',
    bottom: '10%',
    icon: 'circle',
    data: translations,
    textStyle: {
      padding: [0, 3, 0, 0],
    },
  },
});
